import { canBridgeUse, useBridge } from './common';

const namespace = 'ui';
const ua = typeof window !== 'undefined' ? navigator.userAgent : '';

/**
 * config参数按照yoda要求 { title, color }
 * @param {*} config
 * @returns {*} 调用结果
 */
export async function setPageTitle(config) {
    console.log('[bridge] setPageTitle called', config);
    try {
        if (await canBridgeUse(namespace, 'setTitle')) {
            const nameSpaceApi = 'ui.setTitle';
            const res = await useBridge(nameSpaceApi, config);
            console.log('[bridge] setPageTitle ok via ui.setTitle', { config, res });
            return res;
        }
        if (await canBridgeUse(namespace, 'setPageTitle')) {
            const nameSpaceApi = 'ui.setPageTitle';
            const res = await useBridge(nameSpaceApi, config);
            console.log('[bridge] setPageTitle ok via ui.setPageTitle', { config, res });
            return res;
        }
        console.log('[bridge] setPageTitle unsupported: no bridge capability');
    } catch (e) {
        console.log('[bridge] setPageTitle error', { config, error: e && e.message });
        throw e;
    }
    throw new Error('Bridge Unsupported: setPageTitle');
}

export const inYoda = ua.includes('Yoda/');
export const inIm = window.location.pathname.includes('im/message');
export const inCollect = window.location.hostname.includes('collect');
export const isDark = ua.includes('ISDM/1');
export const isHarmony = ua.indexOf('ArkWeb') > -1;